<template>
    <div class="shareThis d-flex justify-content-center align-items-center" @click="settings.shared = false">
        <transition
            enter-active-class="slideInDown"
            leave-active-class="slideOutUp"
        >
            <div v-if="copyLinkMsg" class="msg" :class="danger ? 'alert-danger' : 'alert-success'"> <h3>{{copyLinkMsg}}</h3> </div>
        </transition>
        
        <div class="sharedBox" @click.stop>
            <a target="_blank" :href="('https://www.facebook.com/sharer/sharer.php?u=' + settings.shared.url)">
                <img src="../assets/img/socials/facebook.png" alt="facebook">
            </a>
            <a target="_blank" :href=" ('http://twitter.com/share?text='+settings.shared.title+'&url='+settings.shared.url) ">
                <img src="../assets/img/socials/twitter.png" alt="twitter">
            </a>
            <a target="_blank" :href="('https://www.linkedin.com/shareArticle?mini=true&url='+settings.shared.url+'&title='+settings.shared.title+'&source=&summary='+settings.shared.title)">
                <img src="../assets/img/socials/linkedin.png" alt="linkedin">
            </a>
            <a target="_blank" @click.prevent="copyLink">
                <img src="../assets/img/socials/copy-link.png" alt="linkedin">
            </a>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "ShareThis",
        data() {
            return {
                copyLinkMsg: false,
                danger: false
            }
        },
        computed: {
            ...mapState("shared", ["settings"])
        },
        methods: {
            copyLink(){
                let self = this;
                this.$copyText( this.settings.shared.url ).then(function (e) {
                    self.danger = false;
                    self.copyLinkMsg = 'Link copied to clipboard';
                }, function (e) {
                    self.danger = true;
                    self.copyLinkMsg = 'Can not copy to clipboard';
                })
            }
        },
        watch:{
            copyLinkMsg(){
                if(this.copyLinkMsg){
                    setTimeout(()=> this.copyLinkMsg = "", 5000 );
                }
            }
        }
    }
</script>
